/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``shield-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const ShieldPlusIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M8.78548 0.816414C8.92775 0.795855 9.07225 0.795855 9.21452 0.816414C9.3785 0.840109 9.53108 0.897751 9.65223 0.94352C9.66332 0.947709 9.67414 0.951798 9.68469 0.955753L13.706 2.46376C13.739 2.47611 13.7716 2.4883 13.804 2.50039C14.2674 2.67338 14.6743 2.8253 14.9876 3.10147C15.2618 3.34306 15.4729 3.64778 15.6029 3.98929C15.7514 4.37967 15.7508 4.81401 15.7501 5.30859C15.7501 5.34316 15.75 5.37803 15.75 5.4132V8.99999C15.75 11.12 14.597 12.8874 13.3507 14.1858C12.096 15.4929 10.6605 16.4161 9.90143 16.859C9.89141 16.8648 9.88117 16.8708 9.87069 16.877C9.73217 16.9583 9.55238 17.0639 9.31452 17.1149C9.11993 17.1566 8.88007 17.1566 8.68548 17.1149C8.44762 17.0639 8.26783 16.9583 8.1293 16.877C8.11883 16.8708 8.10859 16.8648 8.09858 16.859C7.3395 16.4161 5.90397 15.4929 4.64929 14.1858C3.40297 12.8874 2.25 11.12 2.25 8.99999V5.4132C2.25 5.37803 2.24995 5.34316 2.2499 5.30859C2.24918 4.81401 2.24855 4.37967 2.39711 3.98929C2.52706 3.64778 2.73823 3.34306 3.01237 3.10147C3.32573 2.8253 3.73264 2.67338 4.19598 2.50039C4.22837 2.4883 4.26103 2.47611 4.29396 2.46376L8.31531 0.955753C8.32586 0.951798 8.33668 0.947709 8.34777 0.943519C8.46892 0.89775 8.6215 0.840109 8.78548 0.816414ZM8.99774 2.30345C8.9671 2.31349 8.92555 2.32891 8.84199 2.36025L4.82065 3.86825C4.20172 4.10035 4.08261 4.15765 4.00412 4.22682C3.91274 4.30735 3.84235 4.40892 3.79904 4.52276C3.76183 4.62053 3.75 4.75218 3.75 5.4132V8.99999C3.75 10.5614 4.60477 11.9733 5.73144 13.1471C6.84975 14.3121 8.15248 15.1538 8.85444 15.5633C8.89734 15.5884 8.92829 15.6064 8.9552 15.6215C8.97632 15.6334 8.99037 15.6409 9 15.6458C9.00963 15.6409 9.02369 15.6334 9.0448 15.6215C9.07171 15.6064 9.10266 15.5884 9.14556 15.5633C9.84752 15.1538 11.1502 14.3121 12.2686 13.1471C13.3952 11.9733 14.25 10.5614 14.25 8.99999V5.4132C14.25 4.75218 14.2382 4.62053 14.201 4.52276C14.1576 4.40892 14.0873 4.30735 13.9959 4.22682C13.9174 4.15765 13.7983 4.10035 13.1794 3.86825L9.15801 2.36025C9.07445 2.32891 9.0329 2.31349 9.00226 2.30345C9.00148 2.30319 9.00072 2.30295 9 2.30271C8.99928 2.30295 8.99852 2.30319 8.99774 2.30345ZM9 5.62499C9.41421 5.62499 9.75 5.96078 9.75 6.37499V7.87499H11.25C11.6642 7.87499 12 8.21078 12 8.62499C12 9.03921 11.6642 9.37499 11.25 9.37499H9.75V10.875C9.75 11.2892 9.41421 11.625 9 11.625C8.58579 11.625 8.25 11.2892 8.25 10.875V9.37499H6.75C6.33579 9.37499 6 9.03921 6 8.62499C6 8.21078 6.33579 7.87499 6.75 7.87499H8.25V6.37499C8.25 5.96078 8.58579 5.62499 9 5.62499Z"
        transform=""
      />
    </g>
  </svg>
);

ShieldPlusIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

ShieldPlusIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

ShieldPlusIcon.displayName = "ShieldPlusIcon";

export default ShieldPlusIcon;
